import { ReportColumnNames } from '@spa/api';

import { ReportTableColumn, ReportTableConfigInterface } from '../../../app/shared/components';

export const TotalsBySymbolsEndBalanceRowId = 'totalsBySymbolsEndBalance';

export const TotalsBySymbolsReportTableConfig = (isGroupReport: boolean): ReportTableConfigInterface => {
    const config = {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Symbol',
                selector: ReportColumnNames.Symbol,
            }),
            new ReportTableColumn({
                label: 'Orders',
                selector: ReportColumnNames.Orders,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Fills',
                selector: ReportColumnNames.Fills,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Currency',
                selector: ReportColumnNames.Currency,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Gross',
                selector: ReportColumnNames.Gross,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Comm',
                selector: ReportColumnNames.COMM,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Ecn Fee',
                selector: ReportColumnNames.ECNFee,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'SEC',
                selector: ReportColumnNames.SEC,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'TAF',
                selector: ReportColumnNames.TAF,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'NSCC',
                selector: ReportColumnNames.NSCC,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'CLR',
                selector: ReportColumnNames.CLR,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'ORF',
                selector: ReportColumnNames.ORF,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'PTFPF',
                selector: ReportColumnNames.PTFPF,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'EFTT',
                selector: ReportColumnNames.EFTT,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'CAT',
                selector: ReportColumnNames.CAT,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Net',
                selector: ReportColumnNames.Net,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Unrealized',
                selector: ReportColumnNames.Unrealized,
                shifted: true
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true
    };

    if (!isGroupReport) {
        config.columns = config.columns
            .filter(column => column.selector !== ReportColumnNames.Currency);
    }

    return config;
};
